var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgContactFormSubmittedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 44.0767L28.1667 55.6667C28.4764 56.1294 28.8923 56.5115 29.3795 56.781C29.8667 57.0506 30.4113 57.1999 30.9679 57.2166C31.5245 57.2332 32.077 57.1167 32.5795 56.8766C33.0819 56.6366 33.5198 56.2801 33.8567 55.8367L60 22.76",
    stroke: "#EA80FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 39.9963C2.5 49.942 6.45088 59.4802 13.4835 66.5128C20.5161 73.5455 30.0544 77.4963 40 77.4963C49.9456 77.4963 59.4839 73.5455 66.5165 66.5128C73.5491 59.4802 77.5 49.942 77.5 39.9963C77.5 30.0507 73.5491 20.5124 66.5165 13.4798C59.4839 6.44722 49.9456 2.49634 40 2.49634C30.0544 2.49634 20.5161 6.44722 13.4835 13.4798C6.45088 20.5124 2.5 30.0507 2.5 39.9963V39.9963Z",
    stroke: "#EA80FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgContactFormSubmittedIcon;